import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { classicBusinessProjectFormSubmitPublicRoute } from '@atlassian/jira-router-routes-business-routes/src/classicBusinessProjectFormSubmitPublicRoute.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { notFoundPageEntrypoint } from '@atlassian/jira-router-routes-not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { formSubmitPageEntrypoint } from './ui/spa/business/form-submit-public/index.tsx';

export const classicBusinessProjectFormSubmitPublicRouteEntry = createEntry(
	classicBusinessProjectFormSubmitPublicRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.form-submit-public-view',
		layout: chromelessLayout,
		resources: [...jiraSpaResources()],

		// This public route should not include
		// DEPRECATED_DO_NOT_USE_projectDetailsResource as a resource, unless we
		// remove all usages of projectKey.
		entryPoint: () =>
			expVal('jira_forms_public_access_experiment', 'isEnabled', 'false')
				? formSubmitPageEntrypoint
				: notFoundPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-business-entries/src/classicBusinessProjectFormSubmitPublicRouteEntry.tsx',
				whichExportToUse: 'classicBusinessProjectFormSubmitPublicRouteEntry',
			},

			enabled: true,
		},
	}),
);
